// extracted by mini-css-extract-plugin
export default {"banner":"Banner-module__banner___jyGMY","no-image":"Banner-module__no-image___K0MNy","mobile":"Banner-module__mobile___L2CGB"};